import * as React from "react";
import { combineHours, toCivilianTime, toDayOfWeek, formatHour } from "../helpers/time";
/**
 * Format location address object to a string
 */

export function formatAddress(_a) {
  var _b = _a === void 0 ? {
    street1: "",
    city: "",
    state: "",
    zip: ""
  } : _a,
      street1 = _b.street1,
      city = _b.city,
      state = _b.state,
      zip = _b.zip;

  var streetStr = street1 ? "".concat(street1, ", ") : "";
  var cityStr = city ? "".concat(city, ", ") : "";
  return "".concat(streetStr).concat(cityStr).concat(state, " ").concat(zip);
}
/**
 * Given an order type, return a prefix for the "____ hours" label.
 */

export function formatOrderType(orderType) {
  if (orderType === "delivery") return "Delivery";
  if (orderType === "pickup") return "Pickup";
  return "Ordering";
}
/**
 * Returns an array of hours, broken up by day.
 */

export function getAllHours(hours, orderType) {
  return hours.map(function (day) {
    var open = day.dineInOpen;
    var close = day.dineInOpen;

    if (orderType === "delivery") {
      open = day.deliveryOpen;
      close = day.deliveryClose;
    }

    if (orderType === "delivery") {
      open = day.pickupOpen;
      close = day.pickupClose;
    }

    var openTime = toCivilianTime(formatHour(open));
    var closeTime = toCivilianTime(formatHour(close));
    return {
      day: day.day,
      time: "".concat(openTime, " - ").concat(closeTime)
    };
  });
}
export function formatAllHours(hours) {
  return React.createElement("ul", {
    style: {
      display: "flex",
      flexDirection: "column",
      margin: 0,
      padding: 0
    }
  }, hours.map(function (_a) {
    var day = _a.day,
        time = _a.time;
    return React.createElement("li", {
      key: day,
      style: {
        display: "flex",
        margin: "0 0 0.5rem 0"
      }
    }, React.createElement("span", {
      style: {
        minWidth: "7rem",
        marginRight: "0.5rem"
      }
    }, toDayOfWeek(day)), React.createElement("span", null, time));
  }));
}
/**
 * Returns the hours for the current day.
 */

export function getTodaysHours(hours, orderType, showDays) {
  if (showDays === void 0) {
    showDays = true;
  }

  var dayOfWeek = new Date().getDay();
  var hour = combineHours(hours)[orderType].find(function (_a) {
    var days = _a.days;
    return days.includes(dayOfWeek);
  });
  return "".concat(showDays ? "".concat(hour.text, ": ") : "").concat(hour.hours);
}